export enum TrialBalanceAdjustringHandling {
ShowColumn,
HideColumn,
HideAndIncludeInPrevBalance,
}
